/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/

import { useSelector } from "react-redux"
import { AppState } from "store/store.type"
import { FeatureFlag } from "constants/features"

/**
 * enableFlexibleModifierQuantityMexPhase2 is a per-merchant flag delivered on
 * merchant.featureFlags (food-max-api getFeatureFlags, already AND-ed with the
 * BE capability flag server-side) and already lives in Redux under
 * menu.outletV2. Read it from there — same pattern as useIsBcrsEnabled — so it
 * resets cleanly on merchant switch (no cross-merchant leak).
 *
 * Gates the FMQ (Flexible Modifier Quantity) modifier-group settings UI:
 * flag absent/false → the FMQ section is completely hidden (Phase-1 behaviour
 * unchanged). See BP-48453.
 */
export const useIsFmqEnabled = (): boolean => {
  const outletV2 = useSelector((state: AppState) => state?.menu?.outletV2)
  return !!outletV2?.featureFlags?.[
    FeatureFlag.enableFlexibleModifierQuantityMexPhase2
  ]
}
